<template>
    <div>
        <div class="user_header_wrap" v-if="$route.name=='Login' || $route.name=='Register' || $route.name=='ForgetPassword' || $route.name=='ResetPassword'">
            <div class="container">
                <div class="user_list_wrap">
                    <ul>
                        <li v-bind:class="{active:$route.name=='Login'}">
                            <router-link v-bind:to="'/login/'" >Login</router-link>
                        </li>
                        <li v-bind:class="{active:$route.name=='Register'}">
                            <router-link v-bind:to="'/register/'">Register</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="header" v-else>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-2 col-3">
                        <div class="logo">
                            <router-link class="" v-bind:to="'/'">
                                <a><img src="../assets/images/logo.png"></a>
                            </router-link>
                        </div>
                    </div> 
                    <div class="col-md-10 col-9">
                        <div class="logins_list logins">
                            <ul>
                                <li v-if="!this.$store.state.auth.isLoggedIn" class="nav-item">
                                    <router-link class="nav-link" v-bind:to="'/login/'">{{ $t("Header.Login") }}</router-link>
                                </li>
                                <li v-if="!this.$store.state.auth.isLoggedIn" class="nav-item">
                                    <router-link class="nav-link" v-bind:to="'/register/'">{{ $t("Header.Register") }}</router-link>
                                </li>
                                <li v-if="this.$store.state.auth.isLoggedIn" class="nav-item">
                                    <router-link class="nav-link" v-bind:to="'/profile/'">{{ $t("Header.Profile") }}</router-link>
                                </li>
                                <li v-if="this.$store.state.auth.isLoggedIn" class="nav-item">
                                    <a class="nav-link" @click.prevent="logout">{{ $t("Header.Logout") }}</a>
                                </li>
                                <!-- <li class="nav-item">
                                    <div class="cart">
                                        <router-link class="nav-link" v-bind:to="'/cart/'">
                                            <i class="fas fa-shopping-cart"></i>
                                            <span class="cart-total-count">{{cart_total_items}}</span>
                                        </router-link>
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../router'
    export default {

        data() {
            this.set_language_class();
            return {
                auth: this.$store.state.auth.isLoggedIn,
                user: this.$store.state.auth.current_user,
                current_locale:this.$i18n_global.locale,
                search_input:'',
                hostname:this.$hostname,
            }
        },
        methods:{
            set_language_class(){
                if(this.$i18n_global.locale=='en'){
                    document.body.classList.add('site-english');
                    document.body.classList.remove('site-arabic');
                }
                else{
                    document.body.classList.add('site-arabic');
                    document.body.classList.remove('site-english');
                }
            },
            logout() {  
                this.$store.commit('logout');
                router.push({name: 'Login',query: { logout: true }})
                return false;
            },
            setNewLocale(event){
                this.$i18n_global.locale = event.target.value;
                this.current_locale = event.target.value
                this.$router.push({
                    params:{lang:this.current_locale}
                })
                localStorage.setItem('lang',this.current_locale);
                window.location.reload();
            },
            search(){
                this.$router.push({
                    name: 'CoursesListing',
                    query: { q: this.search_input }
                })
            },
            async get_meta_information(route){
                var _self = this;
                var data = {
                    type:route.meta.type,
                    name:route.path,
                    slug:route.meta.slug
                };
                console.log(route,"-----------------------------------------------");
                await this.$axios_global.post(_self.$hostname+'/api/get-meta-information',data)
                .then((res) => {
                    var response = res.data.response;
                    $("[data-meta]").remove();
                    $("head").append(`<title data-meta>${response.meta_title}</title><meta data-meta name="description" content="${response.meta_description}"><meta data-meta name="keywords" content="${response.meta_keywords}">`);
                })
                .catch((error) => {
                    return false;
                })
            }
        },
        computed:{
            cart_total_items() {
                return this.$store.state.Cart.cart_total_items
            }
        },
        mounted(){
            this.get_meta_information(this.$route);
        },
        watch: {
            '$route'(route) {
                this.get_meta_information(route);
                return false;
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Header.vue